import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const BlueBookRouteWrapper = (WrappedComponent) => {
  const BlueBookInnerWrapper = (props) => {
    const { blueBookUiFlag, areFeatureFlagsLoaded, route, params } = props;
    const isBlueBookAvailable = blueBookUiFlag && route?.blueBookComponent;

    useEffect(() => {
      const htmlEl = document.querySelector('html');
      if (isBlueBookAvailable) {
        htmlEl.classList.add('html-overflow-hidden');
      }

      return () => {
        if (isBlueBookAvailable) {
          htmlEl.classList.remove('html-overflow-hidden');
        }
      };
    }, [isBlueBookAvailable]);

    if (!areFeatureFlagsLoaded) {
      return null;
    }

    if (isBlueBookAvailable) {
      const { assignmentId } = params;
      return React.createElement(route?.blueBookComponent, {
        ...props,
        assignmentId,
      });
    }

    return <WrappedComponent {...props} />;
  };

  const mapStateToProps = (state) => {
    const { featureFlag, impersonating } = state;
    const apTeacherImpersonatesStudent =
      featureFlag.ap_teacher_impersonates_student;
    const isReadOnly = impersonating && impersonating.isReadOnly;
    return {
      blueBookUiFlag: featureFlag.bluebook_ui,
      isImpersonating:
        Boolean(isReadOnly && apTeacherImpersonatesStudent) ||
        window.localStorage.getItem('isReadOnly') === 'true',
      areFeatureFlagsLoaded: featureFlag.areFeatureFlagsLoaded,
    };
  };

  return connect(mapStateToProps)(BlueBookInnerWrapper);
};

export default BlueBookRouteWrapper;
